<template>
    <div class="card-venue-container d-flex flex-column cursor-pointer" :class="{'isWeekly' : isWeekly}">
        <div class="header d-flex justify-content-between" @click="clickVenue">
            <span>
                {{ info.venueName }}
            </span>
            <img v-if="info.withWarning" class="cursor-pointer" src="@/assets/lingdang.png" height="22px" alt="">
        </div>

        <div class="guidance" v-if="!isWeekly">
            <div v-if="switchDailyGuidance" class="message" :class="{'warning' : !info.revenueStatus}">
                <!-- Daily Guidance -->
                <span class="d-block">
                    {{ info.dailyGuidance }}
                </span>
            </div>
            <div v-else class="message" :class="{'warning' : !info.rosterStatus}">
                <!-- Daily Guidance -->
                <span class="d-block">
                    {{ info.labourMessage }}
                </span>
            </div>

            <div class="btn-switch" @click="switchDailyGuidance = !switchDailyGuidance"></div>
        </div>
        <div class="venue-content-data d-flex flex-column" @click="clickVenue">
            <venue-content :isLoading="isLoading" :isWeekly="isWeekly" :info="info.data.revenue"></venue-content>
            <venue-content :isLoading="isLoading" :isWeekly="isWeekly" :info="info.data.roster"></venue-content>
            <!-- <venue-content v-if="!isPresent" :isLoading="isLoading" :isProfitOnly="isWeekly" :profitIncome="info.profitIncome"></venue-content> -->
        </div>
    </div>
</template>

<style lang='scss'>
@import 'static/scss/colors';
@import 'static/scss/fonts/fonts';
    .card-venue-container {
        min-width: 400;
        width: 414px;
        min-height: 220px;
        padding: 24px;
        
        margin-bottom: 32px;
        border-radius: 10px;
        background-color: $gray2;
        box-shadow: 0px -2px 15px 0px rgba(0, 0, 0, 0.05);
        gap: 10px;
        transition: 0.3s;
        &:hover {
            box-shadow: 0px -2px 15px 0px rgba(0, 0, 0, 0.40);
        }
        &.isWeekly {
            width: 564px;

            .target, .actual, .variance {
                > span {
                    font-size: 18px;
                }
            }
        }
        .header {
            > span {
                @include montserrat-font(20px, normal, 700, $white);
            }
        }

        .guidance {
            gap: 4px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .message {
                @include montserrat-font(14px, normal, 500, $gray3);
                &.warning {
                    > span {
                        color: var(--primary-color);
                    }
                }
                > span {
                    font-size: 16px;
                    font-weight: 700;
                    color: $green;
                    margin-top: 5px;

                   font-weight: 400;
                }
            }
        }

        .venue-content-data {
            gap: 10px;
        }

        
        .btn-switch{
            width: 20px;
            height: 20px;
            cursor: pointer;
            background-repeat: no-repeat;
            background-position: center center;
            background-size: 20px auto;
            background-image: url("../../../assets/t.png");
        }
    }
</style>

<script>
import venueContent from './venueContent.vue';
    export default {
        components: {
            venueContent,
        },
        props: {
            isLoading: {
                default: false,
            },
            isWeekly: {
                default: false,
            },
            isPresent: {
                default: false
            },
            info: {
                default: {
                    venueId: 1,
                    venueName: 'Menard Restaurant',
                    dailyGuidance: 'Increase revenue by $9,233',
                    data: {
                        revenue: {
                            targetLabel: 'Target Revenue',
                            target: '$9,970.40',
                            actualLabel: 'Actual Revenue',
                            actual: '$5,665.50',
                            varianceLabel: 'Variance',
                            variance: '-$11,345.00',
                        },
                        roster: {
                            targetLabel: 'Roster Target',
                            target: '$850.00',
                            actualLabel: 'Actual Roster',
                            actual: '$1,200.36',
                            varianceLabel: 'Variance',
                            variance: '+$3,423.00',
                        }
                    },
                    profitIncome: '$83,300.24',
                }
            }
        },

        data() {
            return {
                switchDailyGuidance: true,
            }
        },
        watch: {
            
        },
        computed: {
            
        },
        methods: {
            clickVenue() {
                this.$emit('select-venue', this.info)
            } 
        },
        mounted() {
            
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/card/venue/index.vue